import React from "react";
import FormComponent from "../Form/FormComponent";
// import { UpdateSurname } from "../Campaign/campaignQueries";
import { Dialog } from "@material-ui/core";
import { withStyles } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import "./AddLinkedin.css";
import Edit from "../assets/pencil.png";
// import store from "../../Redux/Store";
// import { updateCustomerLinkedinCreate } from "../Customers/Customerquery";
import * as Yup from "yup";

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose } = props;

  return (
    <MuiDialogTitle className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : (
        ""
      )}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {}
}))(MuiDialogContent);

export default function CustomizedDialogs(props) {
  const [open, setOpen] = React.useState(
    props.showButton === false ? true : false
  );

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const renderModalContent = props => {
    return (
      <div className="EditGender">
        <FormComponent
          editableData={props.editableData}
          formConfig={Editgender}
          formValidation={Editvalidation}
          modalClose={handleClose}
          buttonName={"Update"}
          message="Gender updated successfully"
          query={props.query}
          updateData={props.updateData}
        />
      </div>
    );
    //}
  };

  return (
    <div>
      <span
        title="Edit"
        style={{ cursor: "pointer", marginRight: "15px" }}
        onClick={handleClickOpen}
      >
        <img src={Edit} alt="Edit" />
      </span>
      {/* <a
        title="Edit"
        style={{ cursor: "pointer", marginRight: "15px" }}
        onClick={handleClickOpen}
      >
        <img src={Edit} alt="Edit" />
      </a> */}

      <div>
        <Dialog aria-labelledby="customized-dialog-title" open={open}>
          <div className="Linkedin">
            <DialogTitle id="customized-dialog-title" onClose={handleClose}>
              <div className="LinkedinTitle">Edit Gender</div>
            </DialogTitle>
            <DialogContent>{renderModalContent(props)}</DialogContent>
          </div>
        </Dialog>
      </div>
    </div>
  );
}

const Editgender = {
  title: "Add New",
  fields: [
    {
      label: "Gender",
      type: "input",
      placeholder: "e.g Mr",
      isRequired: true,
      name: "gender",
      value: " "
    }
  ]
};

const Editvalidation = Yup.object().shape({
  gender: Yup.string()
    .required("Please enter gender")

    .max(10, "Gender should be less than 10 characters")
});
